module.exports = __webpack_public_path__ + "c56f0da010f7fc126f84b26fb10bea18.jpg";